import React, { FC } from 'react'

import { IconScreenRepairProps } from './IconScreenRepair.types'
import * as Styled from './styles/IconScreenRepair.style'

import { nonThemeableRules } from '../../ruleSet'

const IconScreenRepair: FC<IconScreenRepairProps> = ({
  size = nonThemeableRules.defaultSize as number as IconScreenRepairProps['size'],
  isResponsive = false,
}: IconScreenRepairProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M21 39.059h6' stroke='#EA1A1A' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M17 5.066h18V39c0 2.21-1.79 4-4 4H17c-2.21 0-4-1.79-4-4V9.066c0-2.21 1.79-4 4-4Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='m33.762 5.57-4.043 7.352-4.75 3.074L24 24l-3.031 3.031M31.95 8.863 21.022 13.04m8.697-.118 1.265 8.062'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconScreenRepair
